export const QUANTITY_STEPPER_SIZE_XS = 40;
export const QUANTITY_STEPPER_SIZE_SM = 48;
export const QUANTITY_STEPPER_SIZE_MD = 64;

export const ICON_CONTAINER_SIZE_XS = 32;
export const ICON_CONTAINER_SIZE_SM = 40;
export const ICON_CONTAINER_SIZE_MD = 64;

export const ICON_SIZE_XS = 24;
export const ICON_SIZE_SM = 24;
export const ICON_SIZE_MD = 30;
